import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'; // Import Routes and Route instead of Switch
import './index.css';

import Header from './Components/Header';
import AboutMe from './Components/AboutMe';
import Technologies from './Components/Technologies';
import ProjectsNavigation from './Components/ProjectsNavigation';
import Projects from './Components/Projects';
import Contact from './Components/Contact';
import Footer from './Components/Footer';

// import reportWebVitals from './Default/reportWebVitals';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Header switchType="home" />} />
        <Route path="/projects" element={<Header switchType="projects" />} />
      </Routes>
      <Routes>
        <Route path="/" element={
          <>
            <AboutMe />
            <Technologies />
            <Projects displayOption="workingon" title="I'm working on" />
            <Contact />
          </>
        } />
        <Route path="/projects" element={
          <>
            <ProjectsNavigation />
            <Projects displayOption="websites" title="Websites" />
            <Projects displayOption="software" title="Software" />
            <Projects displayOption="3dmodels" title="3D Models" />
            <Projects displayOption="graphicdesign" title="Graphic Design" />
            <Projects displayOption="games" title="Games" />
            <Projects displayOption="illustration" title="Illustration" />
          </>
        } />
        <Route path="*" element={<Navigate to="" />} />
      </Routes>
      <Footer />
    </Router>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// reportWebVitals();